import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, getcountries, getseries, getsubdomains   } from '../../../services/admin/ParticipantForm/approvedFreeParticipantFormServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';

const ApprovedFreeParticipantForm = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({
    id: '',
    accommodation: '',
    accommodation_status: '',
    billing_address: '',
    billing_countries: '',
    billing_email: '',
    billing_full_name: '',
    billing_phone_no: '',
    createdAt: '',
    event_date: '',
    event_title: '',
    event_type: '',
    no_of_ticket: '',
    occupancy_type: '',
    payment_id: '',
    participant_type: '',
    free_status: '',
    receipt_date: '',
    refund_status: '',
    reg_category: '',
    reg_type: '',
    series: '',
    sub_domain: '',
    subject: '',
    total_no_of_nights: '',
    updatedAt: '',
  });
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [seriesFilter, setSeriesFilter]       = useState('');
  const [subDomainFilter, setSubDomainFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
    countries: [],
    series: [],       
    subdomains: [], 
  });

  // Fetch approved data list (free_status: 1)
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ free_status: 1 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  // Fetch dropdown data
  const fetchDropdownData = useCallback(async () => {
  try {
    const [country, subdomains, series] = await Promise.all([
      getcountries(),
      getsubdomains(),
      getseries(),
    ]);

    const uniqueSeries = [...new Set(series.map(item => item.series))].map(s => ({ series: s }));

    setDropdownData({
      countries: country,
      subdomains: subdomains,
      series: uniqueSeries,
    });
  } catch (error) {
    console.error('Error fetching dropdown data:', error);
  }
}, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true);
      await fetchData();
      await fetchDropdownData();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false);
    };
    fetchDataAsync();
  }, [fetchData, fetchDropdownData]);

  const openModal = (data) => {
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getCountryName = (code) => {
    const country = dropdownData.countries.find((c) => c.code === code);
    return country ? country.name : code;
  };

   const filteredData = useMemo(() => {
    return dataList
      .filter((data) => {
        const matchesText =
          data.billing_full_name.toLowerCase().includes(searchText.toLowerCase()) ||
          data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
            data.event_type.toLowerCase().includes(searchText.toLowerCase());

        const matchSeries    = !seriesFilter    || data.series     === seriesFilter;
        const matchSubDomain = !subDomainFilter || data.sub_domain === subDomainFilter;
  
        return matchesText && matchSeries && matchSubDomain;
      })
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }, [dataList, searchText, seriesFilter, subDomainFilter]);
  
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
      name: 'Series',
      selector: (row) => {
        const date = new Date(row.series);
        const year = date.getFullYear();
        const month = date.getMonth();
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${months[month]} ${year}`;
      },
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: 'Sub Domain',
      selector: (row) => row.sub_domain,
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: 'Name',
      selector: (row) => row.billing_full_name,
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.billing_countries),
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: 'Event Type',
      selector: (row) => row.event_type,
      sortable: true,
      wrap: true,
      width: '10%',
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button variant="info" size="sm" onClick={() => openModal(row)}>
            <i className="align-middle far fa-fw fa-eye"></i> View
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        <div className="row m-3 gap-3">
                <div className="col-md-2">
                  <span className='fs-5 text-dark'>Series</span>
                  <select className="form-select" value={seriesFilter} onChange={(e) => setSeriesFilter(e.target.value)}>
                    <option value="">All Series</option>
                    {dropdownData.series
                      .sort((a, b) => b.series.localeCompare(a.series))
                      .map((s) => (
                        <option key={s.series} value={s.series}>{s.series}</option>
                      ))}
                  </select>
                </div>
                <div className="col-md-2">
                  <span className='fs-5 text-dark'>Sub Domain</span>
                  <select className="form-select" value={subDomainFilter} onChange={(e) => setSubDomainFilter(e.target.value)}>
                    <option value="">All Subdomains</option>
                    {dropdownData.subdomains
                      .sort((a, b) => a.sub_domain.localeCompare(b.sub_domain))
                      .map((s) => (
                        <option key={s.sub_domain} value={s.sub_domain}>{s.sub_domain}</option>
                      ))}
                  </select>
                </div>
              </div>      
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: '300px' }}
          >
            <Spinner />
          </div>
        ) : (
          <div>
            <div className="container-fluid p-4">
              <div className="row">
                <div className="col-8">
                  <p className="fs-4 text-dark">
                    Conference Management / Participant Form / Approved Free Participant Form
                  </p>
                </div>
              </div>
              

              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                responsive
                striped
                paginationPerPage={50}
                paginationComponentOptions={{ noRowsPerPage: true }}
                onChangePage={handlePageChange}
                subHeader
                subHeaderComponent={
                  <div>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search"
                      value={searchText}
                      onChange={handleSearchChange}
                    />
                  </div>
                }
              />

              {/* View Only Modal */}
              <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>View Free Participant Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Table striped bordered hover responsive className="table-sm">
                    <thead>
                      <tr>
                        <th className="bg-secondary text-white" colSpan={2}>
                          Payment Receipt Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Event Type</td><td>{form.event_type}</td></tr>
                      <tr><td>Payment ID</td><td>{form.payment_id}</td></tr>
                      <tr><td>Participant Type</td><td>{form.participant_type}</td></tr>
                    </tbody>
                    <br />
                    <thead>
                      <tr>
                        <th className="bg-secondary text-white" colSpan={2}>
                          Billing Address
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Full Name</td><td>{form.billing_full_name}</td></tr>
                      <tr><td>Email</td><td>{form.billing_email}</td></tr>
                      <tr><td>Phone No</td><td>{form.billing_phone_no}</td></tr>
                      <tr><td>Address</td><td>{form.billing_address}</td></tr>
                      <tr><td>Country</td><td>{getCountryName(form.billing_countries)}</td></tr>
                    </tbody>
                    <br />
      
                    <thead>
                      <tr>
                        <th className="bg-secondary text-white" colSpan={2}>
                          Payment Description
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Registration Type</td><td>{form.reg_type}</td></tr>
                      <tr><td>Registration Category</td><td>{form.reg_category}</td></tr>
                      <tr><td>No. of Ticket</td><td>{form.no_of_ticket}</td></tr>
                      {form.occupancy_type && (
                        <tr><td>Occupancy</td><td>{form.occupancy_type}</td></tr>
                      )}
                      {form.total_no_of_nights && (
                        <tr><td>No. of Nights</td><td>{form.total_no_of_nights}</td></tr>
                      )}
                    </tbody>
                  </Table>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

            </div>
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
};

export default ApprovedFreeParticipantForm;